import Overview from "../assets/sidebar/overview.svg";
import Customers from "../assets/sidebar/customer.svg";
import DriverIcon from "../assets/sidebar/driver.svg";
import SupportIcon from "../assets/sidebar/support.svg";
import Admin from "../assets/sidebar/admin.svg";
import executiveSvg from "../assets/sidebar/executiveSvg.svg"
import emptySvg from "../assets/sidebar/no_image.svg"
import insuranceIcon from "../assets/sidebar/insurance.svg";
import flaggedIcon from "../assets/sidebar/flagged.svg";
import FullFillmentIcon from "../assets/sidebar/fullfillment.svg";
import scheduledIcon from "../assets/sidebar/schedule.svg"

const svgIcons = {
  Overview,
  Customer: Customers,
  Drivers: DriverIcon,
  Support: SupportIcon,
  Admin: Admin,
  Flagged: flaggedIcon,
  "Executive Rides": executiveSvg,
  // "Executive Rides": emptySvg,
  "Premium Rides": executiveSvg,
  "All Premium Rides": emptySvg,
  "Insurance": insuranceIcon,
  "Scheduled Rides": scheduledIcon,
};

export function mapAllowedSectionsToMenu(data = []) {
  const menu = [];
  let currentMainMenu = null;

  data.forEach((section, index) => {
    const nextMenu = data[index + 1];

    // Rename Executive to Premium in display text
    const displayTitle = section.text.replace(/Executive/g, "Premium");

    const isSingleLevelMainMenu = ["Overview", "Insurance", "Executive Rides", "Scheduled Rides", "Scheduled Trips", "Scheduled"].includes(section.text);

    if (!section.url || isSingleLevelMainMenu) {
      // Create a new main menu item
      if (currentMainMenu) {
        menu.push(currentMainMenu);
      }

      const path = section?.url ?? nextMenu?.url;

      currentMainMenu = {
        path: `/${path}`,
        title: displayTitle,
        icon: svgIcons[section.text] || null, // Use original text for icon lookup
        subMenu: [],
        disabled: false,
        isHeader: true,
      };
    } else {
      // Add to current main menu's subMenu
      if (currentMainMenu) {
        currentMainMenu.subMenu.push({
          path: `/${section.url}`,
          title: displayTitle,
          disabled: false,
          isHeader: false,
        });
      }
    }
  });

  // Push the last main menu to the array
  if (currentMainMenu) {
    menu.push(currentMainMenu);
  }

  return menu;
}
